var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm.isOpenAdsPopup && !(_vm.loadingPage && _vm.loadingInfoV4) ? _c('div', {
    staticClass: "adv-popup-overlay"
  }, [_c('div', {
    staticClass: "adv-popup-container"
  }, [_c('button', {
    staticClass: "adv-popup-close-button adv-popup-close-action",
    on: {
      "click": function ($event) {
        return _vm.closeAdsPopup();
      }
    }
  }), _c('img', {
    staticClass: "adv-popup-img",
    attrs: {
      "src": ("https://hn.ss.bfcplatform.vn/landingpage-builder/popup_ads.png?t=" + (Date.now())),
      "alt": "Ads"
    },
    on: {
      "click": function ($event) {
        return _vm.toActionAdsPopup();
      }
    }
  })])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }